import { hasWindowParameter } from "./urlParameters";

export enum LogLevel {
    NONE,
    /**
     * Only log errors
     */
    ERROR,
    /**
     * Errors and warnings
     */
    WARN,
    /**
     * Errors, warnings, and the module init process handler registrations
     */
    INIT,
    /**
     * Log everything, including the sent and received messages
     */
    ALL_MESSAGES,
    /**
     * Also log message payloads
     */
    ALL_MESSAGES_AND_PAYLOADS,
}

const forceAllLogs = hasWindowParameter("rlxfeimdebug");

let logLevel: LogLevel = LogLevel.ERROR;

if (forceAllLogs) {
    logLevel = LogLevel.ALL_MESSAGES_AND_PAYLOADS;
}

const getStyle = (level: LogLevel): string =>
{
    if (level <= LogLevel.INIT)
    {
        return "color: #000; background: #a0ecff; padding: 2px 6px; border: 1px solid #888";
    }

    return "color: #000; background: #d9e3e6; padding: 2px 6px;";
};

const debugLog = (message: string): void =>
{
    if (forceAllLogs) {
        window.rlxfeim.log.push(message);
    }
};

export const setLogLevel = (value?: LogLevel): void =>
{
    if (!forceAllLogs && value !== undefined)
    {
        logLevel = value;
    }
};

export const log = (message: string, level: LogLevel = LogLevel.ALL_MESSAGES, data?: object): void =>
{
    if (logLevel >= level)
    {
        if (data !== undefined
            && (logLevel >= LogLevel.ALL_MESSAGES_AND_PAYLOADS || level <= LogLevel.INIT))
        {
            message += " " + JSON.stringify(data);
        }

        debugLog(message);
        console.log(`%c[FEIM]%c${message}`, "color: #000; margin-right: 4px; background: #a0ecff; padding: 2px 6px; border: 1px solid #888", getStyle(level));
    }
};

export const warn = (message: string, level: LogLevel = LogLevel.WARN): void =>
{
    if (logLevel >= level)
    {
        debugLog(message);
        console.warn(`[FEIM] ${message}`);
    }
};

export const error = (message: string): void =>
{
    if (logLevel > LogLevel.NONE)
    {
        debugLog(message);
        console.error(`[FEIM] ${message}`);
    }
};
